import React from 'react'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import InputAdornment from '@material-ui/core/InputAdornment'
import { useFormikContext } from 'formik'
import { PerformantTextField } from './perfomant-textfield'

import { useProjectFormStyles } from './project-form.styles'
import { FormValuesProjectRequest } from '../projects.types'
import { useTranslation } from '@plandi/common'

export const ProjectFormCharacteristics = () => {
  const classes = useProjectFormStyles()
  const { data: translate } = useTranslation()
  const formik = useFormikContext<FormValuesProjectRequest>()

  return (
    <Accordion className={classes.accordion} elevation={2} defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h5">
          {translate?.market?.characteristics}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        <PerformantTextField
          label={translate?.market?.['site-area']}
          type="text"
          fullWidth
          variant="outlined"
          margin="normal"
          InputProps={{
            endAdornment: (
              <InputAdornment position="start" disableTypography>
                <Typography variant="body2" color="textSecondary">
                  м<sup className={classes.sup}>2</sup>
                </Typography>
              </InputAdornment>
            )
          }}
          name="landArea"
          onChangePar="isFractal"
          value={formik.values.landArea ?? ''}
          helperText={formik.errors.landArea}
          error={Boolean(formik.errors.landArea)}
          disabled={formik.isSubmitting}
        />
        <PerformantTextField
          label={translate?.market?.['construction-area']}
          type="text"
          fullWidth
          variant="outlined"
          margin="normal"
          InputProps={{
            endAdornment: (
              <InputAdornment position="start" disableTypography>
                <Typography variant="body2" color="textSecondary">
                  м<sup className={classes.sup}>2</sup>
                </Typography>
              </InputAdornment>
            )
          }}
          name="builtUpArea"
          onChangePar="isFractal"
          value={formik.values.builtUpArea ?? ''}
          helperText={formik.errors.builtUpArea}
          error={Boolean(formik.errors.builtUpArea)}
          disabled={formik.isSubmitting}
        />
        <PerformantTextField
          label={translate?.market?.['building-area']}
          type="text"
          fullWidth
          variant="outlined"
          margin="normal"
          InputProps={{
            endAdornment: (
              <InputAdornment position="start" disableTypography>
                <Typography variant="body2" color="textSecondary">
                  м<sup className={classes.sup}>2</sup>
                </Typography>
              </InputAdornment>
            )
          }}
          name="buildingArea"
          onChangePar="isFractal"
          value={formik.values.buildingArea ?? ''}
          helperText={formik.errors.buildingArea}
          error={Boolean(formik.errors.buildingArea)}
          disabled={formik.isSubmitting}
        />
        <PerformantTextField
          label={translate?.market?.['building-height']}
          type="text"
          fullWidth
          variant="outlined"
          margin="normal"
          InputProps={{
            endAdornment: (
              <InputAdornment position="start" disableTypography>
                <Typography variant="body2" color="textSecondary">
                  м
                </Typography>
              </InputAdornment>
            )
          }}
          name="buildingHeight"
          onChangePar="isFractal"
          value={formik.values.buildingHeight ?? ''}
          helperText={formik.errors.buildingHeight}
          error={Boolean(formik.errors.buildingHeight)}
          disabled={formik.isSubmitting}
        />
        <PerformantTextField
          label={translate?.market?.['number-floors']}
          type="text"
          fullWidth
          variant="outlined"
          margin="normal"
          name="numberOfFloors"
          onChangePar="isInteger"
          value={formik.values.numberOfFloors ?? ''}
          helperText={formik.errors.numberOfFloors}
          error={Boolean(formik.errors.numberOfFloors)}
          disabled={formik.isSubmitting}
        />
      </AccordionDetails>
    </Accordion>
  )
}
